var map = {
	"./goldcoin/btn-icon-boost.png": 29464,
	"./memetown/btn-icon-boost.png": 4477,
	"./reflection/btn-icon-boost.png": 82096,
	"./tapcoin/btn-icon-boost.png": 97498
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64090;